import types from '../mutation-types';
import { persistConversationPrefetchSnapshot } from 'dashboard/helper/conversationPrefetchCache';

const CONVERSATION_CACHE_MUTATIONS = new Set([
  types.SET_ALL_CONVERSATION,
  types.UPDATE_CONVERSATION,
  types.ADD_MESSAGE,
  types.UPDATE_MESSAGE_REACTIONS,
  types.DELETE_MESSAGE,
  types.SET_PREVIOUS_CONVERSATIONS,
  types.SET_MISSING_MESSAGES,
  types.SET_ALL_MESSAGES_LOADED,
  types.CLEAR_ALL_MESSAGES_LOADED,
  types.SET_CHAT_DATA_FETCHED,
  types.SET_CONVERSATION_PREFETCH_PROGRESS,
  types.DELETE_CONVERSATION,
  types.ASSIGN_AGENT,
  types.ASSIGN_TEAM,
  types.ASSIGN_PRIORITY,
  types.UPDATE_CONVERSATION_CUSTOM_ATTRIBUTES,
  types.UPDATE_CONVERSATION_LAST_ACTIVITY,
  types.UPDATE_CONVERSATION_PIN,
  types.MUTE_CONVERSATION,
  types.UNMUTE_CONVERSATION,
  types.CHANGE_CONVERSATION_STATUS,
  types.UPDATE_MESSAGE_UNREAD_COUNT,
  types.UPDATE_MESSAGE_CALL_STATUS,
]);

const PERSIST_DEBOUNCE_MS = 400;

const createConversationPrefetchCachePlugin = () => store => {
  let persistTimer = null;

  const flushConversationPrefetchSnapshot = () => {
    if (persistTimer) {
      window.clearTimeout(persistTimer);
      persistTimer = null;
    }

    const accountId = store.getters.getCurrentAccountId;
    const userId = store.getters.getCurrentUserID;

    if (!accountId || !userId) {
      return;
    }

    persistConversationPrefetchSnapshot({
      accountId,
      userId,
      conversations: store.state.conversations.allConversations,
    });
  };

  const scheduleConversationPrefetchSnapshot = () => {
    if (typeof window === 'undefined') {
      return;
    }

    if (persistTimer) {
      window.clearTimeout(persistTimer);
    }

    persistTimer = window.setTimeout(() => {
      persistTimer = null;
      flushConversationPrefetchSnapshot();
    }, PERSIST_DEBOUNCE_MS);
  };

  store.subscribe(mutation => {
    if (!CONVERSATION_CACHE_MUTATIONS.has(mutation.type)) {
      return;
    }

    if (mutation.type === types.EMPTY_ALL_CONVERSATION) {
      return;
    }

    scheduleConversationPrefetchSnapshot();
  });

  if (typeof window !== 'undefined') {
    const handlePageHide = () => {
      flushConversationPrefetchSnapshot();
    };

    window.addEventListener('beforeunload', handlePageHide);
    window.addEventListener('pagehide', handlePageHide);
  }
};

export default createConversationPrefetchCachePlugin;
